import React, { useCallback } from 'react';

import Drawer from '@atlaskit/drawer';

import { useCompanyHubBuilderStore } from './CompanyHubBuilderStore';

export const CompanyHubBuilderDrawer = () => {
	const [builderDrawerState, { closeDrawer }] = useCompanyHubBuilderStore();

	const reset = useCallback(() => {
		closeDrawer();
	}, [closeDrawer]);

	return (
		<Drawer width="full" isOpen={builderDrawerState.showDrawer} onClose={reset}>
			<div>Company Hub Builder!</div>
		</Drawer>
	);
};
